import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  page: { padding: 24, fontSize: 10, fontFamily: 'Helvetica', color: '#111827' },
  title: { fontSize: 16, fontWeight: 700, marginBottom: 4 },
  subtitle: { fontSize: 10, color: '#4b5563', marginBottom: 12 },
  summaryGrid: { flexDirection: 'row', flexWrap: 'wrap', gap: 8, marginBottom: 10 },
  summaryCard: { width: '48%', borderWidth: 1, borderColor: '#e5e7eb', padding: 6, borderRadius: 4 },
  summaryLabel: { fontSize: 8, color: '#6b7280' },
  summaryValue: { fontSize: 11, fontWeight: 700, marginTop: 2 },
  table: { borderWidth: 1, borderColor: '#e5e7eb' },
  row: { flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: '#f3f4f6' },
  headerRow: { backgroundColor: '#f9fafb' },
  // flexBasis:0 + a per-cell `flexGrow` weight makes each column size by its
  // weight (not its text), so header and body cells line up into true columns.
  // Give a table proportional columns by overriding flexGrow per cell, e.g.
  // [styles.cell, { flexGrow: 27 }]. (Do NOT use a percentage `width` on these
  // cells — flexBasis:0 overrides it and the cell collapses to its content.)
  cell: { paddingVertical: 5, paddingHorizontal: 6, fontSize: 8.5, flexGrow: 1, flexBasis: 0 },
  headText: { fontWeight: 700, color: '#374151' },
  right: { textAlign: 'right' },
});

export const formatDate = (value?: string): string => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString('en-GB');
};
